import React from 'react';

const pageContainer: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 24,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const sectionHeader: React.CSSProperties = {
  color: '#AAB5E0',
  fontSize: 22,
  textAlign: 'center',
  marginTop: 24,
  marginBottom: 16,
};

const question: React.CSSProperties = {
  color: '#AAB5E0',
  fontSize: 18,
  marginTop: 12,
};

const answer: React.CSSProperties = {
  color: '#FFF',
  fontSize: 14,
  marginTop: 4,
  opacity: 0.95,
};

const TenantFaqPage: React.FC = () => {
  return (
    <div style={pageContainer}>
      <div style={shellCard}>
        <h1 style={{ fontSize: 22, fontWeight: 600 }}>FAQ</h1>

        <div style={sectionHeader}>General</div>
        <div style={question}>What is Bins Storage?</div>
        <div style={answer}>
          Bins is a platform that connects storage facilities, customers, and
          drivers. Our platform facilitates valet / full-service storage,
          offering tenants the option to have items picked up or delivered,
          removing the hassle of having to lift or drive.
        </div>

        <div style={question}>Where is Bins offered?</div>
        <div style={answer}>
          You can store items in any of the storage facilities that have
          partnered with Bins. Currently, we are in the San Francisco Bay Area,
          with plans to expand to other regions.
        </div>

        <div style={question}>
          What’s the difference between valet storage and self storage?
        </div>
        <div style={answer}>
          With self storage, the tenant is responsible for everything – packing,
          driving, and moving into the unit. With valet storage, drivers will
          pick up or deliver your items, removing the need to physically go to
          the storage facility.
        </div>

        <div style={sectionHeader}>Pricing and payments</div>
        <div style={question}>How much does storage cost?</div>
        <div style={answer}>
          Bins offers a variety of different plans and options so tenants can
          browse and select a plan that works best for them.
        </div>

        <div style={question}>When will I be billed?</div>
        <div style={answer}>
          You will be charged on the day your items are moved into storage, and
          monthly thereafter. You will also be charged for new pickups and
          deliveries.
        </div>

        <div style={question}>How do I pay?</div>
        <div style={answer}>
          We accept payment from most major credit cards.
        </div>

        <div style={sectionHeader}>Storing</div>
        <div style={question}>What size are the bins?</div>
        <div style={answer}>All bins are 60cm × 40cm × 31.5cm.</div>

        <div style={question}>Can you store large or bulky items?</div>
        <div style={answer}>
          Yes, you can store furniture and other large items with us.
        </div>

        <div style={sectionHeader}>Orders</div>
        <div style={question}>How do I request an order?</div>
        <div style={answer}>
          Go to your items and select the items you’d like stored or returned,
          then schedule your appointment. We’ll come by to pick up or drop off
          your items.
        </div>

        <div style={question}>How do I create a new bin?</div>
        <div style={answer}>
          Pack a bin with the belongings you want to store, then under &quot;Items
          with you&quot; create a new item by adding a photo and description. It
          will then be ready to be picked up and stored.
        </div>

        <div style={question}>How much does an order cost?</div>
        <div style={answer}>
          Each facility will have their own pickup and delivery costs. Some may
          offer promotions such as free initial pickups.
        </div>

        <div style={question}>How do I cancel an order?</div>
        <div style={answer}>
          You can call or email to cancel an order. All orders must be canceled
          48 hours before the scheduled appointment time.
        </div>
      </div>
    </div>
  );
};

export default TenantFaqPage;
